if (!customElements.get('instagram-carousel')) {
  class InstagramCarousel extends HTMLElement {
    constructor() {
      super();

      if (this.dataset.contentSource !== 'app') return;

      this.app = this.querySelector('.instafeed-shopify') || this.querySelector('#insta-feed');
      this.items = this.querySelector('.swiper-wrapper');
      this.container = this.querySelector('.swiper-container');
      this.scrollbar = this.querySelector('.swiper-scrollbar');
      this.isFigmaLayout = this.classList.contains('instagram-carousel--homepage-figma');

      if (!this.app || !this.items) return;

      this.itemLimit = this.isFigmaLayout ? 4 : 5;
      this.observeAppFeed();

      if (!this.isFigmaLayout) {
        this.desktopMedia = window.matchMedia('(min-width: 1200px)');
        this.handleMediaChange = () => this.updateLegacyCarousel();
        this.desktopMedia.addEventListener('change', this.handleMediaChange);
        this.updateLegacyCarousel();
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.desktopMedia?.removeEventListener('change', this.handleMediaChange);
      this.swiper?.destroy();
    }

    observeAppFeed() {
      this.observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.target.querySelectorAll('.instafeed-new-layout-item').forEach((item) => {
            if (this.items.children.length >= this.itemLimit) return;

            const slide = document.createElement('div');
            slide.classList.add('swiper-slide', 'card');
            slide.append(item);
            this.items.append(slide);
          });
        });

        if (this.items.children.length >= this.itemLimit) {
          this.observer.disconnect();
        }
      });

      this.observer.observe(this.app, { childList: true });
    }

    updateLegacyCarousel() {
      if (this.desktopMedia.matches) {
        this.swiper?.destroy();
        this.swiper = undefined;
        return;
      }

      if (!this.swiper && window.Swiper) {
        this.swiper = new Swiper(this.container, {
          loop: false,
          grabCursor: true,
          speed: 500,
          spaceBetween: 8,
          slidesPerView: 3,
          scrollbar: { el: this.scrollbar, enabled: true },
          breakpoints: { 992: { spaceBetween: 16, slidesPerView: 4 } },
        });
      }
    }
  }

  customElements.define('instagram-carousel', InstagramCarousel);
}
